import * as Constants from "./constants";

/**
 * Cleans a given path for the ImageKit CDN.
 *
 * @param path The image path.
 * @returns The new image path.
 */
export function cleanImagePathForImageKit(path: string) {
  return path
    .replace(Constants.serviceURLs.kentico.assets, "")
    .replace(Constants.serviceURLs.kentico.assetsUS, "")
    .replace(Constants.serviceURLs.kentico.previewAssets, "")
    .replace(Constants.serviceURLs.kentico.previewAssetsUS, "");
}

/**
 * Converts Kentico Kontent image URLs into ImageKit URLs.
 *
 * @param path The image path.
 * @returns The ImageKit URL.
 */
export function convertKontentImageURLToImageKitURL(path: string, width:number=740 ) {
  const imageKitParameters = `tr:w-${width},pr-true,f-auto`;

  return `${Constants.serviceURLs.imagekit.main}${imageKitParameters}/${cleanImagePathForImageKit(
    path,
  )}`;
}
